export const nonEmptyStringRule = (
  text = 'Please enter a non-empty string.'
) => ({
  validate: {
    text: (value: string) => {
      if (value.trim() === '') {
        return text
      }

      return true
    },
  },
})

export const slugRule = {
  validate: {
    text: (value: string) => {
      const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
      if (!slugRegex.test(value.trim())) {
        return 'Invalid slug format. Use lowercase alphanumeric characters and hyphens only, no leading/trailing hyphens.'
      }
      return true
    },
  },
}

export const urlRule = {
  validate: {
    url: (value: string) => {
      try {
        const _url = new URL(value)
        return true
      } catch {
        return 'Please enter a valid URL'
      }
    },
  },
}
